(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  (() => {
    if (window.__footerMenuAccordionInstalled) return;
    window.__footerMenuAccordionInstalled = true;
    document.documentElement.classList.add('has-footer-menu-accordion');
    const mobileQuery = window.matchMedia('(max-width: 767px)');

    const getFooterItems = () => Array.from(document.querySelectorAll('[data-footer-menu-root] [data-footer-menu-item]'));

    const closeFooterMenu = (item) => {
      const toggle = item.querySelector('[data-footer-menu-toggle]');
      const panel = item.querySelector('[data-footer-menu-panel]');
      if (!toggle || !panel) return;
      panel.style.maxHeight = `${panel.scrollHeight}px`;
      requestAnimationFrame(() => {
        item.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
        panel.setAttribute('aria-hidden', 'true');
        panel.setAttribute('inert', '');
        panel.style.maxHeight = '0px';
      });
    };

    const openFooterMenu = (item) => {
      const toggle = item.querySelector('[data-footer-menu-toggle]');
      const panel = item.querySelector('[data-footer-menu-panel]');
      if (!toggle || !panel) return;
      item.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      panel.setAttribute('aria-hidden', 'false');
      panel.removeAttribute('inert');
      panel.style.maxHeight = '0px';
      requestAnimationFrame(() => {
        panel.style.maxHeight = `${panel.scrollHeight + 64}px`;
      });
      if (panel.dataset.expandListener !== 'true') {
        panel.dataset.expandListener = 'true';
        panel.addEventListener('transitionend', (event) => {
          if (event.propertyName === 'max-height' && item.classList.contains('is-open')) {
            panel.style.maxHeight = 'none';
          }
        });
      }
    };

    const syncFooterMenus = () => {
      const isMobile = mobileQuery.matches;
      getFooterItems().forEach((item) => {
        const toggle = item.querySelector('[data-footer-menu-toggle]');
        const panel = item.querySelector('[data-footer-menu-panel]');
        if (!toggle || !panel) return;

        if (isMobile) {
          item.classList.remove('is-open');
          toggle.disabled = false;
          toggle.setAttribute('aria-expanded', 'false');
          panel.setAttribute('aria-hidden', 'true');
          panel.setAttribute('inert', '');
          panel.style.maxHeight = '0px';
        } else {
          item.classList.add('is-open');
          toggle.disabled = true;
          toggle.setAttribute('aria-expanded', 'true');
          panel.setAttribute('aria-hidden', 'false');
          panel.removeAttribute('inert');
          panel.style.maxHeight = 'none';
        }
      });
    };

    syncFooterMenus();
    if (mobileQuery.addEventListener) mobileQuery.addEventListener('change', syncFooterMenus);
    else mobileQuery.addListener(syncFooterMenus);

    document.addEventListener('click', (event) => {
      if (!mobileQuery.matches) return;
      const toggle = event.target.closest('[data-footer-menu-toggle]');
      if (toggle) {
        const item = toggle.closest('[data-footer-menu-item]');
        if (!item) return;
        const shouldOpen = toggle.getAttribute('aria-expanded') !== 'true';
        document.querySelectorAll('[data-footer-menu-root] [data-footer-menu-item].is-open').forEach((openItem) => {
          if (openItem !== item) closeFooterMenu(openItem);
        });
        if (shouldOpen) openFooterMenu(item);
        else closeFooterMenu(item);
        return;
      }

      document.querySelectorAll('[data-footer-menu-root] [data-footer-menu-item].is-open').forEach((openItem) => {
        if (!openItem.contains(event.target)) closeFooterMenu(openItem);
      });
    });

    document.addEventListener('keydown', (event) => {
      if (!mobileQuery.matches || event.key !== 'Escape') return;
      document.querySelectorAll('[data-footer-menu-root] [data-footer-menu-item].is-open').forEach((openItem) => {
        const toggle = openItem.querySelector('[data-footer-menu-toggle]');
        closeFooterMenu(openItem);
        toggle?.focus();
      });
    });

    window.addEventListener('resize', () => {
      if (!mobileQuery.matches) return;
      document.querySelectorAll('[data-footer-menu-root] [data-footer-menu-item].is-open [data-footer-menu-panel]').forEach((panel) => {
        if (panel.style.maxHeight !== 'none') panel.style.maxHeight = `${panel.scrollHeight + 64}px`;
      });
    });

    /* Mobile-only Payment Icon Tooltip (3-second countdown, resets on every tap) */
    let paymentTooltipTimer = null;
    let lastTouchTimestamp = 0;

    const getOfficialPaymentName = (li) => {
      if (li.dataset.officialPaymentName) return li.dataset.officialPaymentName;
      const svgTitle = li.querySelector('svg title, title');
      if (svgTitle && svgTitle.textContent.trim()) {
        const officialName = svgTitle.textContent.trim();
        li.dataset.officialPaymentName = officialName;
        return officialName;
      }
      const rawType = li.getAttribute('data-payment-type') || '';
      if (rawType) {
        const formatted = rawType
          .replace(/[-_]+/g, ' ')
          .replace(/\b\w/g, (char) => char.toUpperCase());
        li.dataset.officialPaymentName = formatted;
        return formatted;
      }
      return '';
    };

    const hideAllPaymentTooltips = (exceptLi = null) => {
      document.querySelectorAll('.footer__aside .payment-methods li.is-tooltip-visible').forEach((item) => {
        if (item !== exceptLi) {
          item.classList.remove('is-tooltip-visible');
        }
      });
    };

    const triggerMobilePaymentTooltip = (li) => {
      if (!mobileQuery.matches) return;
      const officialName = getOfficialPaymentName(li);
      if (!officialName) return;

      if (paymentTooltipTimer) {
        clearTimeout(paymentTooltipTimer);
        paymentTooltipTimer = null;
      }

      hideAllPaymentTooltips(li);

      let tooltipEl = li.querySelector('.payment-tooltip');
      if (!tooltipEl) {
        tooltipEl = document.createElement('span');
        tooltipEl.className = 'payment-tooltip';
        tooltipEl.setAttribute('role', 'tooltip');
        tooltipEl.textContent = officialName;
        li.appendChild(tooltipEl);
      } else {
        tooltipEl.textContent = officialName;
      }

      li.classList.add('is-tooltip-visible');

      paymentTooltipTimer = window.setTimeout(() => {
        li.classList.remove('is-tooltip-visible');
        paymentTooltipTimer = null;
      }, 3000);
    };

    document.addEventListener('touchstart', (event) => {
      if (!mobileQuery.matches) return;
      const paymentLi = event.target.closest('.footer__aside .payment-methods li');
      if (paymentLi) {
        lastTouchTimestamp = Date.now();
        triggerMobilePaymentTooltip(paymentLi);
      } else {
        if (paymentTooltipTimer) {
          clearTimeout(paymentTooltipTimer);
          paymentTooltipTimer = null;
        }
        hideAllPaymentTooltips();
      }
    }, { passive: true });

    document.addEventListener('click', (event) => {
      if (!mobileQuery.matches) return;
      if (Date.now() - lastTouchTimestamp < 450) return;
      const paymentLi = event.target.closest('.footer__aside .payment-methods li');
      if (paymentLi) {
        triggerMobilePaymentTooltip(paymentLi);
      } else {
        if (paymentTooltipTimer) {
          clearTimeout(paymentTooltipTimer);
          paymentTooltipTimer = null;
        }
        hideAllPaymentTooltips();
      }
    });

    window.addEventListener('resize', () => {
      if (!mobileQuery.matches) {
        if (paymentTooltipTimer) {
          clearTimeout(paymentTooltipTimer);
          paymentTooltipTimer = null;
        }
        hideAllPaymentTooltips();
      }
    });

    /* Desktop-only Social Media Icon Hover Tooltip (Official Name) */
    const resolveOfficialSocialName = (link) => {
      if (link.dataset.officialSocialName) return link.dataset.officialSocialName;
      const rawLabel = (link.getAttribute('data-social-name') || link.getAttribute('aria-label') || link.getAttribute('title') || '').trim();
      const href = (link.getAttribute('href') || '').toLowerCase();

      const cleanedLabel = rawLabel
        .replace(/^(follow\s+on|follow\s+us\s+on|تابعنا\s+على)\s+/i, '')
        .trim();

      if (cleanedLabel) {
        link.dataset.officialSocialName = cleanedLabel;
        return cleanedLabel;
      }

      const socialMap = [
        ['instagram.com', 'Instagram'],
        ['facebook.com', 'Facebook'],
        ['wa.me', 'WhatsApp'],
        ['whatsapp.com', 'WhatsApp'],
        ['x.com', 'X'],
        ['twitter.com', 'X'],
        ['tiktok.com', 'TikTok'],
        ['snapchat.com', 'Snapchat'],
        ['youtube.com', 'YouTube'],
        ['youtu.be', 'YouTube'],
        ['linkedin.com', 'LinkedIn'],
        ['pinterest.', 'Pinterest'],
        ['threads.net', 'Threads'],
        ['discord.', 'Discord'],
        ['mailto:', 'Email'],
        ['tel:', 'Phone']
      ];

      for (const [pattern, official] of socialMap) {
        if (href.includes(pattern)) {
          link.dataset.officialSocialName = official;
          return official;
        }
      }

      return '';
    };

    const initDesktopSocialTooltips = () => {
      document.querySelectorAll('.footer__aside .footer__social-media a').forEach((link) => {
        const officialName = resolveOfficialSocialName(link);
        if (!officialName) return;

        if (link.hasAttribute('title')) {
          link.removeAttribute('title');
        }
        if (link.hasAttribute('onmouseover')) {
          link.removeAttribute('onmouseover');
        }
        if (link.hasAttribute('onmouseout')) {
          link.removeAttribute('onmouseout');
        }

        let tooltipEl = link.querySelector('.social-tooltip');
        if (!tooltipEl) {
          tooltipEl = document.createElement('span');
          tooltipEl.className = 'social-tooltip';
          tooltipEl.setAttribute('role', 'tooltip');
          tooltipEl.textContent = officialName;
          link.appendChild(tooltipEl);
        } else {
          tooltipEl.textContent = officialName;
        }
      });
    };

    initDesktopSocialTooltips();
    document.addEventListener('shopify:section:load', initDesktopSocialTooltips);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-with-icons"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__textWithIconsAutoplayInstalled) return;
    window.__textWithIconsAutoplayInstalled = true;

    const selector = 'scroll-carousel[data-text-with-icons-carousel][data-autoplay-interval]';
    const cleanups = new WeakMap();

    const initialize = (root) => {
      root.querySelectorAll(selector).forEach((carousel) => {
        if (cleanups.has(carousel)) return;

        const interval = Math.max(2000, Number(carousel.dataset.autoplayInterval) || 5000);
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reducedMotion) return;

        let timer;
        let hovered = false;
        let focused = false;
        let pressed = false;

        const clearTimer = () => window.clearTimeout(timer);
        const schedule = () => {
          clearTimer();
          if (hovered || focused || pressed || document.visibilityState === 'hidden') return;
          timer = window.setTimeout(advance, interval);
        };
        const advance = () => {
          if (window.matchMedia('(min-width: 700px)').matches) {
            schedule();
            return;
          }

          const cells = carousel.cells || Array.from(carousel.querySelectorAll('.text-with-icons__item'));
          const lastIndex = cells.length - 1;
          if (lastIndex < 1) return;

          if (typeof carousel.select === 'function' && typeof carousel.selectedIndex === 'number') {
            if (carousel.selectedIndex >= lastIndex) {
              carousel.select(0, { instant: true });
            } else {
              carousel.select(carousel.selectedIndex + 1);
            }
          }

          schedule();
        };
        const onPointerEnter = () => { hovered = true; schedule(); };
        const onPointerLeave = () => { hovered = false; schedule(); };
        const onFocusIn = () => { focused = true; schedule(); };
        const onFocusOut = (event) => {
          if (!carousel.contains(event.relatedTarget)) focused = false;
          schedule();
        };
        const onPointerDown = () => { pressed = true; schedule(); };
        const onPointerUp = () => { pressed = false; schedule(); };
        const onVisibilityChange = () => schedule();

        carousel.addEventListener('pointerenter', onPointerEnter);
        carousel.addEventListener('pointerleave', onPointerLeave);
        carousel.addEventListener('focusin', onFocusIn);
        carousel.addEventListener('focusout', onFocusOut);
        carousel.addEventListener('pointerdown', onPointerDown);
        document.addEventListener('pointerup', onPointerUp);
        document.addEventListener('pointercancel', onPointerUp);
        document.addEventListener('visibilitychange', onVisibilityChange);

        const cleanup = () => {
          clearTimer();
          carousel.removeEventListener('pointerenter', onPointerEnter);
          carousel.removeEventListener('pointerleave', onPointerLeave);
          carousel.removeEventListener('focusin', onFocusIn);
          carousel.removeEventListener('focusout', onFocusOut);
          carousel.removeEventListener('pointerdown', onPointerDown);
          document.removeEventListener('pointerup', onPointerUp);
          document.removeEventListener('pointercancel', onPointerUp);
          document.removeEventListener('visibilitychange', onVisibilityChange);
        };

        cleanups.set(carousel, cleanup);
        schedule();
      });
    };

    initialize(document);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll(selector).forEach((carousel) => cleanups.get(carousel)?.());
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
